import { render, staticRenderFns } from "./deleteOweFeeCallable.vue?vue&type=template&id=01be7b8a"
import script from "./deleteOweFeeCallable.vue?vue&type=script&lang=js"
export * from "./deleteOweFeeCallable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports